// 수강권(패스/티켓)/일일권 편집 폼의 FormData 전송 공통 유틸.
//
// 과거 패스/티켓은 Object.keys(filteredData) 를 통째로 도는 deny-list(excludeFields) 방식이라,
// 제외 목록에 빠진 필드(예: sportTypes 배열)가 그대로 새어나가 백엔드 List 바인딩이 깨지는 버그가 있었다.
// 이 유틸은 "보낼 필드만 명시"하는 allow-list 방식으로, 명시하지 않은 잔여 데이터는 절대 전송되지 않는다.

// 종료일 플래그는 프론트(true = 종료일 없음)와 서버(true = 종료일 있음) 의미가 반대라 반전해서 전송한다.
const INVERTED_BOOLEAN_KEYS = new Set(['hasSaleEndDate', 'hasDiscountEndDate']);

// 단일 필드를 FormData 에 추가한다.
// - null/undefined 는 건너뛴다.
// - 배열은 같은 key 로 원소를 반복 append 한다 (백엔드 List<T> 바인딩).
// - 종료일 플래그는 의미가 반대라 반전한다.
export const appendField = (formData, key, value) => {
  if (value === null || value === undefined) return;
  if (INVERTED_BOOLEAN_KEYS.has(key)) {
    formData.append(key, !value);
    return;
  }
  if (Array.isArray(value)) {
    value.forEach(item => formData.append(key, item));
    return;
  }
  formData.append(key, value);
};

// allow-list(보낼 필드 목록)에 해당하는 값만 source 에서 골라 FormData 에 추가한다.
export const appendFields = (formData, source, allowedKeys) => {
  allowedKeys.forEach(key => appendField(formData, key, source[key]));
};
